ALLOWED_CONTROLLER = 'people'
ALLOWED_ACTIONS = ['show']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $('input[type="checkbox"][id^="free_rental"]').on 'change', (e)->
    rental_id = e.target.getAttribute('data-rental-id')
    $(".modal#endRentalModal#{rental_id} .charge_info").toggle(!e.target.checked)
    $(".modal#endRentalModal#{rental_id} .free_rental_info").toggle(e.target.checked)

$(document).ready(ready)
$(document).on('turbo:load', ready)
